export const LoginTestIDs = {
  usernameInput: "login-username-input",
  passwordInput: "login-password-input",
  loginButton: "login-login-button",
};
